import axios from 'axios';
import { _createAlert } from './apiUtils';

export const paycorDownloadFile = async (startDate: string, endDate: string) => {
    try {
      // URL for getting the token for authentication
      const tokenUrl = "https://admin.api.wcdp.com/adminApi/User/AdminLogin";
      
      // Employee credentials for login
      const employeeId = "27016";
      const password = "27016";
  
      // URL for downloading the payroll report
      const reportUrl = "https://admin.api.wcdp.com/adminApi/Payroll/ExportPayrollFilePaycor";
  
      // Make a POST request to get the authentication token using employee credentials
      const tokenResponse = await axios.post(tokenUrl, { employeeId, password });
  
      // Extract the token from the response
      const token = tokenResponse.data.token;
  
      // If the token is not retrieved, log an error and return
      if (!token) {
        console.error("Failed to retrieve token.");
        return;
      }
  
      // Prepare the query parameters for the date range
      const params = new URLSearchParams();
      params.append("startDate", startDate);
      params.append("endDate", endDate);
  
      // Log the date range for debugging purposes
      console.log(startDate, endDate);
  
      // Make a GET request to download the report, passing the token and query parameters
      const response = await axios.get(reportUrl, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
        params: params,  // Include the date range as query parameters
      });
  
      // If the response indicates failure, log the error and return
      if (response.data.success === false) {
        console.error("Download Failed: " + response.data.errorMessage);
        return;
      }

      // Return the data if the report is downloaded successfully
      return response.data;
      
    } catch (error) {
      // Log any errors encountered during the process
      console.error("Error getting file:", error);
      // Trigger an alert with the error message
      _createAlert("Download Failed:", `${error}`); 
      // Throw a new error to indicate failure
      throw new Error("Failed to download file.");
    }
};

export const manualPaycorDownloadFile = async (startDate: string, endDate: string, empIDs: string) => {
  try {
    console.log("Starting manualPaycorDownloadFile with parameters:", { startDate, endDate, empIDs });

    // URL for getting the token for authentication
    const tokenUrl = "https://admin.api.wcdp.com/adminApi/User/AdminLogin";
    
    // Employee credentials for login
    const employeeId = "27016";
    const password = "27016";

    // URL for downloading the payroll report
    const reportUrl = "https://admin.api.wcdp.com/adminApi/Payroll/ExportPayrollFilePaycorManual";

    // Make a POST request to get the authentication token using employee credentials
    const tokenResponse = await axios.post(tokenUrl, { employeeId, password });
    console.log("Token Response:", tokenResponse);

    // Extract the token from the response
    const token = tokenResponse.data.token;

    // If the token is not retrieved, log an error and return
    if (!token) {
      console.error("Failed to retrieve token.");
      _createAlert("Authentication Failed", "Could not retrieve authentication token.");
      return;
    }

    // Prepare the query parameters for the date range and employee IDs
    const params = new URLSearchParams();
    params.append("startDate", startDate);
    params.append("endDate", endDate);
    params.append("employeeIDs", empIDs);

    console.log("Params:", params.toString());

    // Make a GET request to download the report, passing the token and query parameters
    const response = await axios.get(reportUrl, {
      headers: {
        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      },
      params: params,  // Include the date range as query parameters
    });

    console.log("Response:", response);

    // If the response indicates failure, log the error and return
    if (response.data.success === false) {
      console.error("Download Failed: " + response.data.errorMessage);
      _createAlert("Download Failed", response.data.errorMessage);
      return;
    }

    // Return the data if the report is downloaded successfully
    return response.data;

  } catch (error: any) {
    console.error("Error getting file:", error);
    _createAlert("Download Failed:", `${error.message || error}`);
    throw new Error("Failed to download file.");
  }
};
